"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lodash = _interopRequireDefault(require("lodash.frompairs"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactTable = _interopRequireDefault(require("react-table"));

var _selectTable = _interopRequireDefault(require("react-table/lib/hoc/selectTable"));

var _TableHeader = _interopRequireDefault(require("./TableHeader"));

var _TablePagination = _interopRequireDefault(require("./TablePagination"));

var _TableSelect = _interopRequireDefault(require("./TableSelect"));

var _TableSpinner = _interopRequireDefault(require("./TableSpinner"));

var _TableNoData = _interopRequireDefault(require("./TableNoData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CheckboxReactTable = (0, _selectTable["default"])(_reactTable["default"]);
var defaultPageSizes = [10, 20, 50, 100];
var headerHeightAffectingProps = ['condensed', 'filterable'];

var Table =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Table, _PureComponent);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "tableRef", null);

    _defineProperty(_assertThisInitialized(_this), "containerRef", (0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "state", {
      resolvedData: _this.props.data,
      // eslint-disable-line react/no-unused-state
      selections: {},
      entireHeaderHeight: 0
    });

    _defineProperty(_assertThisInitialized(_this), "setMeasurements", function () {
      var _this$containerRef$cu = _this.containerRef.current.getElementsByClassName('ReactTable'),
          _this$containerRef$cu2 = _slicedToArray(_this$containerRef$cu, 1),
          rt = _this$containerRef$cu2[0];

      var headers = Array.from(rt.getElementsByClassName('rt-thead'));

      _this.setState({
        entireHeaderHeight: headers.reduce(function (agg, h) {
          return agg + h.offsetHeight;
        }, 0)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVisibleData", function () {
      if (!_this.tableRef) {
        return _this.props.data || [];
      }

      var resolvedState = _this.tableRef.getWrappedInstance().getResolvedState();

      var pageStart = resolvedState.page * resolvedState.pageSize;
      var pageEnd = (resolvedState.page + 1) * resolvedState.pageSize;
      return resolvedState.resolvedData.slice(pageStart, pageEnd);
    });

    _defineProperty(_assertThisInitialized(_this), "getVisibleSelections", function () {
      var keyField = _this.props.keyField;
      var selections = _this.state.selections;

      var visibleData = _this.getVisibleData();

      var visibleKeys = visibleData.map(function (row) {
        var key = row[keyField];
        return [key, selections[key]];
      });
      return (0, _lodash["default"])(visibleKeys);
    });

    _defineProperty(_assertThisInitialized(_this), "getPaginationProps", function () {
      var condensed = _this.props.condensed;
      return {
        condensed: condensed
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getTableRef", function (tableRef) {
      _this.tableRef = tableRef;
    });

    _defineProperty(_assertThisInitialized(_this), "getTheadThProps", function (state, row, column) {
      var sortable = [column.sortable, state.sortable, false].find(function (x) {
        return x != null;
      });
      var sorted = state.sorted.find(function (x) {
        return x.id === column.id;
      });
      return {
        sortable: sortable,
        sorted: sorted
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getSharedProps", function (_ref) {
      var loading = _ref.loading,
          condensed = _ref.condensed,
          filterable = _ref.filterable;
      return {
        loading: loading,
        entireHeaderHeight: _this.state.entireHeaderHeight,
        condensed: condensed,
        filterable: filterable
      };
    });

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMeasurements();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (headerHeightAffectingProps.some(function (prop) {
        return _this2.props[prop] !== prevProps[prop];
      })) {
        this.setMeasurements();
      }
    } // get the height of the header to use as the offset to the LoadingComponent and NoDataComponent

  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          condensed = _this$props.condensed,
          selectable = _this$props.selectable;

      var props = _objectSpread({
        ref: this.getTableRef,
        className: (0, _classnames["default"])(className, {
          'table-condensed': condensed
        }),
        // Callbacks for providing custom props to individual components
        getPaginationProps: this.getPaginationProps,
        getTheadThProps: this.getTheadThProps,
        getNoDataProps: this.getSharedProps,
        getLoadingProps: this.getSharedProps,
        ThComponent: _TableHeader["default"],
        // Defaults for pagination
        defaultPageSize: 10,
        pageSizeOptions: defaultPageSizes,
        LoadingComponent: _TableSpinner["default"],
        NoDataComponent: _TableNoData["default"],
        PaginationComponent: _TablePagination["default"],
        // Selection state and callbacks
        selectType: 'checkbox',
        selectWidth: 73,
        // Magic number that is 2 times left padding plus checkbox width.
        SelectAllInputComponent: _TableSelect["default"],
        SelectInputComponent: _TableSelect["default"],
        style: {
          position: 'relative'
        }
      }, this.props);

      return _react["default"].createElement("div", {
        ref: this.containerRef
      }, selectable ? _react["default"].createElement(CheckboxReactTable, props) : _react["default"].createElement(_reactTable["default"], props));
    }
  }]);

  return Table;
}(_react.PureComponent);

exports["default"] = Table;
Table.propTypes = {
  className: _propTypes["default"].string,
  condensed: _propTypes["default"].bool,
  selectable: _propTypes["default"].bool,
  data: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  keyField: _propTypes["default"].any // eslint-disable-line react/forbid-prop-types

};